import { useMutation } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useCallback } from 'react';

import {
  GetLineVisitDetailDocument,
  SendCongestionNotificationForLineVisitorDocument,
} from '~/graphql/generated/graphql';
import { lineVisitorNotificationCongestionModalState } from '~/state/reception/atoms';

export const useSendCongestionNotification = () => {
  const { isOpen, appointmentId } = useAtomValue(lineVisitorNotificationCongestionModalState);
  const resetNotificationCongestionModalState = useResetAtom(
    lineVisitorNotificationCongestionModalState,
  );

  const [sendNotification, { loading, error }] = useMutation(
    SendCongestionNotificationForLineVisitorDocument,
    {
      refetchQueries: [{ query: GetLineVisitDetailDocument, variables: { id: appointmentId } }],
    },
  );

  const handleSend = useCallback(
    async (content: string) => {
      if (!appointmentId || !isOpen) return;

      try {
        await sendNotification({
          variables: {
            input: {
              content,
              appointmentId,
            },
          },
        });

        resetNotificationCongestionModalState();
      } catch {
        // 何もしない
      }
    },
    [appointmentId, isOpen, sendNotification, resetNotificationCongestionModalState],
  );

  return { loading, error, handleSend };
};
